import { CommonModule, PlatformLocation } from '@angular/common';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule
} from '@angular/core';
import { AppInit } from '@app/helper/AppInit';
import { Constants } from 'src/app/constants';

import { ChatComponent } from './components/live-chat.component';
import { SettingService } from './services/setting.service';

export function configureAuth(
  platformLocation: PlatformLocation,
  settings: SettingService
): () => Promise<any> {
  return () => {
    return AppInit()().then(() => {
      settings.loadConfig({
        messagingScriptUrl: Constants.appConfiguration.messagingScriptUrl,
        scrt2Url: Constants.appConfiguration.scrt2Url,
        orgId: Constants.appConfiguration.orgId,
        messagingName: Constants.appConfiguration.messagingName,
        messagingUrl: Constants.appConfiguration.messagingUrl
      });
    });
  };
}
@NgModule({
  imports: [CommonModule],
  exports: [CommonModule, ChatComponent],
  declarations: [ChatComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LiveChatModule {
  static forRoot(): ModuleWithProviders<LiveChatModule> {
    return {
      ngModule: LiveChatModule,
      providers: [
        SettingService,
        {
          provide: APP_INITIALIZER,
          useFactory: configureAuth,
          deps: [PlatformLocation, SettingService],
          multi: true
        }
      ]
    };
  }
}
